import { render, staticRenderFns } from "./calendar-panel.vue?vue&type=template&id=bd650b94&scoped=true&"
import script from "./calendar-panel.vue?vue&type=script&lang=ts&"
export * from "./calendar-panel.vue?vue&type=script&lang=ts&"
import style0 from "./calendar-panel.vue?vue&type=style&index=0&id=bd650b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd650b94",
  null
  
)

export default component.exports